import type { OnInit } from "@angular/core";
import { Component, ElementRef, Input, Renderer2, forwardRef } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import type { TeamGroup } from "../team-group";
import { ApiParams } from "@shared/http/api-params";
import { TeamGroupFetcher } from "../team-group.fetcher";
import { BaseSelectFormFieldComponent } from "@shared/form-fields/select/base-select-form-field.component";

@Component({
    selector: 'app-team-group-select',
    templateUrl: '../../../form-fields/select/select-form-field.component.html',
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => TeamGroupSelectComponent),
        multi: true
    }],
}) export class TeamGroupSelectComponent extends BaseSelectFormFieldComponent<TeamGroup> implements OnInit {
    @Input() params: ApiParams = {};
    @Input() valueKey?: string;

    constructor(element: ElementRef,
        renderer: Renderer2,
        private fetcher: TeamGroupFetcher) {
        super(element, renderer);
    }

    ngOnInit(): void {
        super.ngOnInit();

        if (this.fetchFromApi) {
            this.fetcher.all({
                ...this.params,
                order_by: 'description',
                direction: 'asc',
            }).subscribe(response => {
                this.apiOptions = response.data.map(group => ({
                    label: group.description,
                    value: this.valueKey ? group[this.valueKey] : group
                }));
            });
        }
    }
}